import api from '../../api'

// Typed client for the shipped child-profile contract.
// Routes (lvbl_backend/lvbl/member/urls.py):
//   GET/POST     member/children/
//   PATCH/DELETE member/children/<uuid:child_id>/   (DELETE = 204 No Content = archive/soft-delete)
// Auth: imports the default `api` instance only, so the Firebase ID token is
// auto-injected by the request interceptor (no unauthenticated path for child PII).

export interface Child {
  id: string
  display_name: string
  date_of_birth: string | null
  archived_at: string | null
  created_at: string
}

export const getChildren = async () => {
  const res = await api.get('member/children/')
  return res.data
}

export const postChild = async (data: { display_name: string; date_of_birth: string | null }) => {
  const res = await api.post('member/children/', data)
  return res.data
}

export const patchChild = async ({
  id,
  data,
}: {
  id: string
  data: { display_name?: string; date_of_birth?: string | null }
}) => {
  const res = await api.patch(`member/children/${id}/`, data)
  return res.data
}

// DELETE returns 204 No Content (archive). The empty body is expected — do not
// read res.data meaningfully.
export const deleteChild = async ({ id }: { id: string }) => {
  const res = await api.delete(`member/children/${id}/`)
  return res.data
}
